import { render, staticRenderFns } from "./Prix.vue?vue&type=template&id=5b97c8b2&"
import script from "./Prix.vue?vue&type=script&lang=ts&"
export * from "./Prix.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports